(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("LegoElement", ["React"], factory);
	else if(typeof exports === 'object')
		exports["LegoElement"] = factory(require("React"));
	else
		root["LegoElement"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_39__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition